import React from 'react';
import { Trash2, Archive, Wrench, Users, Car } from 'lucide-react';

import DeletedRepairOrdersPage from './DeletedRepairOrdersPage';

interface Props {}

interface State {
    isLoading: boolean;
    activeTab: number;
    repairOrdersCount: number;
}

class DeletedItemsPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: false,
            activeTab: 0,

            repairOrdersCount: 0,
        };
    }
    getTabs() {
        return [
            {
                title: 'Repair Orders',
                icon: Wrench,
                component: (
                    <DeletedRepairOrdersPage
                        onRepairOrdersCountChange={(count) => this.setState({ repairOrdersCount: count })}
                    />
                ),
            },
            // { title: 'Customer', icon: Users, component: <AccessPointsTab name="test" /> },
            // { title: 'Vehicles', icon: Car, component: <VehiclesTable name="test" /> },
        ];
    }
    render() {
        const tabs = this.getTabs();
        const { isLoading, activeTab, repairOrdersCount } = this.state;

        return (
            <div className="flex flex-col min-h-screen bg-gray-50">
                {/* Header */}
                <div className="bg-white border-b border-gray-200 px-8 py-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-2">
                                <span>Settings</span>
                                <span>/</span>
                                <span className="text-blue-600 font-semibold ">Deleted Items</span>
                            </nav>
                            <p className="text-gray-600 mt-1">
                                Manage and restore deleted items from your repair shop system.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex-1 p-8">
                    {/* Statistics Panel */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="flex items-center space-x-2 mb-4">
                            <Trash2 className="h-5 w-5 text-gray-600" />
                            <h3 className="text-lg font-semibold text-gray-900">Archived Items Overview</h3>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="bg-red-50 rounded-lg p-4 border border-red-200">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-sm font-medium text-red-600">Deleted Repair Orders</p>
                                        <p className="text-2xl font-bold text-red-900">{repairOrdersCount}</p>
                                    </div>
                                    <Wrench className="h-8 w-8 text-red-600" />
                                </div>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="flex items-center justify-between">
                                    {' '}
                                    <div>
                                        <p className="text-sm font-medium text-gray-600">Deleted Customers</p>
                                        <p className="text-2xl font-bold text-gray-900">--</p>
                                        <p className="text-xs text-gray-500">Coming soon</p>
                                    </div>
                                    <Users className="h-8 w-8 text-gray-400" />
                                </div>
                            </div>
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-sm font-medium text-gray-600">Deleted Vehicles</p>
                                        <p className="text-2xl font-bold text-gray-900">--</p>
                                        <p className="text-xs text-gray-500">Coming soon</p>
                                    </div>
                                    <Car className="h-8 w-8 text-gray-400" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Info Panel */}
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                        <div className="flex items-start space-x-3">
                            <Archive className="h-5 w-5 text-blue-600 mt-0.5" />
                            <div>
                                <h4 className="text-sm font-semibold text-blue-900">About Deleted Items</h4>
                                <p className="text-sm text-blue-700 mt-1">
                                    Items that are deleted from your system are moved here for recovery. You can restore
                                    deleted items or permanently remove them. Items are automatically purged after 180
                                    days to maintain system performance.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Tabs Navigation */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                        {!isLoading && (
                            <div className="border-b border-gray-200">
                                <nav className="flex space-x-8 px-6">
                                    {tabs.map((tab, index) => {
                                        const IconComponent = tab.icon;
                                        return (
                                            <button
                                                key={index}
                                                onClick={() => this.setState({ activeTab: index })}
                                                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                                                    activeTab === index
                                                        ? 'border-blue-500 text-blue-600'
                                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                                }`}
                                            >
                                                <IconComponent className="h-4 w-4" />
                                                <span>{tab.title}</span>
                                            </button>
                                        );
                                    })}
                                </nav>
                            </div>
                        )}

                        {/* Tab Content */}
                        <div className="p-6">{tabs[activeTab].component}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeletedItemsPage;
